import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ContactService } from 'src/app/services/contact.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
})
export class ContactComponent implements OnInit {
  fg: FormGroup;
  constructor(
    private _builder: FormBuilder,
    private _contact: ContactService
    ) {}

  ngOnInit(): void {

    

    this.fg = this._builder.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      message: ['', Validators.required],
    });
  }
 

  onSubmit(fg) {

this._contact.PostMessage(fg)
.subscribe(response => {
  location.href = 'https://petar-djordjevic.netlify.app'

}, error => {


})
}
}
